import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { LinkableAccount } from '../../_models/fundraising/LinkableAccount';
import { VendorUser } from '../../_models/fundraising/Vendor';
import { Location } from '../../_models/fundraising/Location';
import { getUrl } from '../../_shared/utils';
import { JWTTokenService } from '../jwtToken.service';

@Injectable()
export class VendorService {

  public apiUrl = getUrl();

  constructor(
    private http: HttpClient,
    private jwtTokenService: JWTTokenService) { }


    public getAll(): Observable<VendorUser[]> {
        return this.http.get<VendorUser[]>(getUrl('vendor'), this.requestOptionsAuthenticated('portal'));
    }

    public getAllVendorUsers(): Observable<VendorUser[]> {
      return this.http.get<VendorUser[]>(getUrl('vendor/users'), this.requestOptionsAuthenticated('portal'));
  }

    public getLinkableVendors(): Observable<LinkableAccount[]> {
      return this.http.get<LinkableAccount[]>(getUrl('vendor/linkable'), this.requestOptionsAuthenticated('portal'));
    }

    public getLinkedMerchants(vendorId: number): Observable<LinkableAccount[]> {
      return this.http.get<LinkableAccount[]>(getUrl('vendor/linked-merchants/' + vendorId), this.requestOptionsAuthenticated('portal'));
    }

    public getById(vendorId: number): Observable<VendorUser> {
        return this.http.get<VendorUser>(getUrl('vendor/' + vendorId), this.requestOptionsAuthenticated('portal'));
    }

    public checkBarrelPrinting(vendorId: number): Observable<boolean> {
      return this.http.get<boolean>(getUrl('vendor/barrel/' + vendorId), this.requestOptionsAuthenticated('portal'));
  }

    public getVendorAsCurrentUser(): Observable<VendorUser> {
      return this.http.get<VendorUser>(getUrl('vendor/current-user'), this.requestOptionsAuthenticated('portal'));
    }

    public getVendorUserById(vendorUserId: number): Observable<VendorUser> {
      return this.http.get<VendorUser>(getUrl('vendor/user/' + vendorUserId), this.requestOptionsAuthenticated('portal'));
  }

    public create(vendorData): Observable<any> {
      return this.http.post<any>(getUrl('vendor/create'), vendorData, this.requestOptionsAuthenticated('portal'));
    }

    public updateLinkedMerchants(accountId: number, linkedAccounts: LinkableAccount[]): Observable<any> {
      const vendorData = { accountId, linkedAccounts };
      return this.http.post<any>(getUrl('vendor/update-linked-merchants'), vendorData, this.requestOptionsAuthenticated('portal'));
    }

    public delete(vendorId: number): Observable<any> {
      return this.http.get<any>(getUrl('vendor/delete/' + vendorId), this.requestOptionsAuthenticated('portal'));
  }

    public update(vendorData): Observable<any> {
      return this.http.post<any>(getUrl('vendor/update'), vendorData, this.requestOptionsAuthenticated('portal'));
    }

    public resendPortalOnboardingUrl(vendorId: number): Observable<any> {
      return this.http.get<any>(getUrl('vendor/resend-invite/' + vendorId), this.requestOptionsAuthenticated('portal'));
    }

    public register(email: string, password: string) {
      const vendorData = { email, password };
      return this.http.post<any>(getUrl('vendor/register'), vendorData, this.requestOptionsAuthenticated('onboarding'));
    }

    public activate() {
      return this.http.get<any>(getUrl('vendor/activate'), this.requestOptionsAuthenticated('stripe-onboarding'));
    }

    public getVendorLocations(): Observable<Location[]> {
      return this.http.get<Location[]>(getUrl(`vendor/location`), this.requestOptionsAuthenticated('portal'));
    }

    public getVendorLocationById(locationId: number): Observable<Location> {
      return this.http.get<Location>(getUrl(`vendor/location/${locationId}`), this.requestOptionsAuthenticated('portal'));
    }

    public createVendorLocation(locationData: Location): Observable<any> {
      return this.http.post<any>(getUrl('vendor/location/create'), locationData, this.requestOptionsAuthenticated('portal'));
    }

    public deleteLocation(id: number): Observable<any> {
      return this.http.get<any>(getUrl(`vendor/location/delete/${id}`), this.requestOptionsAuthenticated('portal'));
    }

    public updateVendorLocation(locationData: Location): Observable<any> {
      return this.http.post<any>(getUrl('vendor/location/update'), locationData, this.requestOptionsAuthenticated('portal'));
    }

    public getFundraisingEventTypes () : Observable<any> {
      return this.http.get<any>(getUrl('vendor/event-types'), this.requestOptionsAuthenticated('portal'));
    }

    public createVendorUser(vendorUserData) : Observable<any> {

      return this.http.post<any>(getUrl('vendor/create-user'), vendorUserData, this.requestOptionsAuthenticated('portal'));
    }

    public registerVendorUser(email: string, password: string) : Observable<any> {

      const vendorUserData = { email, password };
      return this.http.post<any>(getUrl('vendor/register-user'), vendorUserData, this.requestOptionsAuthenticated('vendorUserOnboarding'));
    }

    public deleteVendorUser(vendorUserId: number) : Observable<any> {

      return this.http.delete<any>(getUrl(`vendor/delete-user/${vendorUserId}`), this.requestOptionsAuthenticated('portal'));
    }

    public addVendorSupportEmails(emails: string[]): Observable<any> {

      return this.http.post<any>(getUrl('vendor/support-emails/add'), emails, this.requestOptionsAuthenticated('portal'));
    }

    private requestOptionsAuthenticated(tokenKey: string) {
        const requestOptions = {
            headers: new HttpHeaders()
                .set('Content-type', 'application/json')
                .append('Authorization', 'Bearer ' + this.jwtTokenService.getToken(tokenKey)),
        };
        return requestOptions;
    }
}

